<template>
  <section id="invoice_code">
    <Styles>
      <vs-button
        color="primary"
        type="filled"
        icon="add"
        class="mb-3 btn-add-new"
        v-if="!show"
        @click="addNew()"
      >
        Agregar nueva máscara
      </vs-button>
      <br />
      <b-table
        :data="getMaskActiveList()"
        :selected.sync="selectedMaks"
        v-if="!show"
        class="mask-list"
      >
        <b-table-column field="mask" label="Máscara" v-slot="props">
          {{ props.row.mask }}
        </b-table-column>
        <b-table-column field="mask" label="Calcula por" v-slot="props">
          {{ getSectionName(props.row.section) }}
        </b-table-column>
        <b-table-column field="mask" label="Opciones" v-slot="props">
          <vs-button
            title="Editar"
            color="primary"
            type="filled"
            icon="edit"
            @click="edit(props.row)"
          ></vs-button>
          <vs-button
            title="Eliminar"
            class="ml-2"
            color="danger"
            type="filled"
            icon="delete"
            @click="remove(props.row)"
          ></vs-button>
        </b-table-column>
        <template #empty>
          <div class="has-text-centered">Sin registros</div>
        </template>
      </b-table>
      <div class="widget" v-if="show">
        <h2 class="w-title">Configura la máscara de tu descuento</h2>
        <div class="columns mt-2">
          <div class="column">
            <b-field label="Ingrese un código de barras:" v-if="!editing">
              <b-input
                placeholder="Ingresar código barras"
                type="text"
                name="name"
                v-model="invoiceCode"
              />
            </b-field>
          </div>
        </div>
        <!-- <div class="columns">
          <div class="column">
            <b-field label="Ingrese la máscara:" v-if="!editing">
              <b-input
                placeholder="Ingrese la máscara"
                type="text"
                name="name"
                v-model="maskInput"
              />
            </b-field>
          </div>
        </div> -->
        <div class="columns widget-content" v-if="limit > 0">
          <div class="column table-content">
            <div class="table-values">
              <div class="body">
                <div class="b-header">
                  <div class="col th subject">Sección</div>
                  <div class="col th value">Dígitos ({{ limit }})</div>
                  <div class="col th mask">Máscara</div>
                </div>
                <draggable v-model="maskItems">
                  <div
                    :class="`item unselectable ${
                      item.code == section ? 'selected' : ''
                    }`"
                    v-for="(item, index) in maskItems"
                    :value="item.code"
                    :key="item.code"
                    :id="item.code"
                  >
                    <label class="col subject label"
                      >{{ item.label }}
                      <button class="btn-close" @click="removeSection(item)">
                        &times;
                      </button>
                    </label>
                    <div class="col input-content">
                      <b-input
                        :id="`num-${index}`"
                        placeholder="# de dígitos"
                        type="number"
                        v-model="item.num"
                        name="num"
                      />
                    </div>
                    <div class="col input-content">
                      <b-input
                        :id="`mask-${index}`"
                        placeholder="Máscara"
                        type="text"
                        v-model="item.mask"
                        v-validate="'required'"
                        name="mask"
                        :disabled="true"
                      />
                    </div>
                  </div>
                </draggable>
                <div class="item unselectable">
                  <div class="col subject align-left">
                    <b-select
                      placeholder="Seleccione una sección"
                      expanded
                      class="select"
                      v-model="sectionAdd"
                      name="sectionAdd"
                    >
                      <option
                        v-for="option in sections"
                        :value="option.code"
                        :key="option.code"
                        :id="option.code"
                      >
                        {{ option.label }}
                      </option>
                    </b-select>
                  </div>
                  <div class="col align-left">
                    <vs-button
                      color="primary"
                      class="pl-5 pr-5"
                      type="filled"
                      icon="add"
                      @click="addSection"
                    >
                      Agregar sección
                    </vs-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="column"
            v-if="Array.isArray(maskItems) && maskItems.length > 0"
          >
            <div class="mask-content">
              <label class="label" v-if="!maskItems"
                >Sin información aún para mostrar la máscara</label
              >
              <div class="mask-positions">
                <label class="label">Selecciona las posiciones</label>
                <div class="position-controler">
                  <draggable v-model="maskItems">
                    <div
                      :class="`option unselectable ${
                        item.code == section ? 'selected' : ''
                      }`"
                      v-for="item in getFilledMaskItems()"
                      :value="item.code"
                      :key="item.code"
                      :id="item.code"
                      :title="item.label"
                      @click="setSection(item.code)"
                    >
                      {{ getLabelMask(item) }}
                    </div>
                  </draggable>
                </div>
              </div>
              <label class="label mt-5">Máscara final:</label>
              <label class="final-mask">{{ getFinalMaks() }}</label>
              <div class="display-block mt-4">
                <b-field label="Sección para calcular" class="mb-3">
                  <b-select
                    placeholder="Seleccione una opción"
                    expanded
                    v-model="section"
                    name="section"
                  >
                    <option
                      v-for="option in maskItems"
                      :value="option.code"
                      :key="option.code"
                      :id="option.code"
                    >
                      {{ option.label }}
                    </option>
                  </b-select>
                </b-field>
                <b-button @click="confirmMask()" type="is-info"
                  >Confirmar
                </b-button>
                <b-button @click="cancelMask()" type="is-dark ml-2">
                  Cancelar
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <b-loading :is-full-page="true" v-model="isLoading"></b-loading>
    </Styles>
  </section>
</template>

<script>
import Styles from "./styles";
import draggable from "vuedraggable";
import { confirmation } from "../../../global/utils";
import { ROUTES } from "../../../global/api_routes";
import { configToast, TOAST_TYPES } from "../../../global/toast";
export default {
  name: "InvoiceCode",
  components: { Styles, draggable },
  props: {
    maskList: {
      type: Array,
      default: [],
    },
  },
  data: () => ({
    isLoading: false,
    sectionAdd: null,
    show: false,
    editing: false,
    invoiceCode: "1234567890",
    selectedMaks: null,
    limit: 10,
    section: null,
    maskItems: [],
    finalMask: null,
    rowEdit: null,
    sections: [],
  }),
  watch: {
    invoiceCode() {
      this.limit = this.invoiceCode.length;
      const maskItems = this.maskItems;
      const generalNum = Math.floor(this.limit / maskItems.length);
      const lastValue = this.limit - this.maskItems.length * generalNum;
      const list = maskItems.map((item, index) => ({
        ...item,
        num:
          index == maskItems.length - 1 ? generalNum + lastValue : generalNum,
      }));
      this.maskItems = list;
      console.log(list);
    },
    maskItems() {
      this.finalMask = this.getFinalMaks();
    },
    selectedMaks() {
      console.log(this.selectedMaks);
      this.setMask(this.selectedMaks);
    },
  },
  mounted() {
    this.finalMask = this.getFinalMaks();
    this.getSections();
  },
  methods: {
    removeSection(item) {
      confirmation(this, "¿Desea eliminar realmente la sección?").then(
        (result) => {
          if (!result) {
            return;
          }
          this.maskItems = this.maskItems.filter(
            (temp) => temp.index !== item.index
          );
          this.selectedMaks = null;
        }
      );
    },
    addSection() {
      if (!this.sectionAdd) {
        this.toast("Selecciona una sección", TOAST_TYPES.ERROR);
        return;
      }
      const section = this.sections.find(
        (item) => this.sectionAdd == item.code
      );
      this.maskItems = [
        ...this.maskItems,
        { ...section, index: this.maskItems.length },
      ];
    },
    getMaskActiveList() {
      return this.maskList.filter((item) => !item.delete);
    },
    toast(message, type = TOAST_TYPES.INFO) {
      const instance = configToast(this, "#invoice_code");
      return instance.open(message, type);
    },
    getSections() {
      this.isLoading = true;
      this.$http
        .get(ROUTES.DASHBOARD.DISCOUNTS.GET_SECTIONS)
        .then(({ data }) => {
          if (data.code > 0) {
            this.sections = data.info.map((item) => ({
              index: item.code,
              code: item.code,
              label: item.title,
              mask: item.initials,
              num: 4,
            }));
            // this.maskItems = [...this.originMaskItems];
            console.log("SECTIONS", this.maskList);
            return;
          }
          this.toast(data.message, TOAST_TYPES.ERROR);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    cancelMask() {
      this.show = false;
    },
    addNew() {
      this.show = true;
      this.rowEdit = null;
      this.section = null;
      console.log(this.maskList);
      console.log(this.sections);
      this.maskItems = [];
    },
    setSection(code) {
      this.section = code;
    },
    edit(row) {
      this.index = row.index;
      this.editing = true;
      this.show = true;
      this.maskItems = row.maskDetails;
      this.section = row.section;
      this.finalMask = row.mask;
      this.selectedMaks = row;
      this.rowEdit = row;
      console.log("ROW:", row);
    },
    remove(row) {
      confirmation(this, "¿Desea eliminar realmente el registro?").then(
        (result) => {
          if (!result) {
            return;
          }
          console.log("ELIMINAR", row);
          this.$emit("updateMask", { ...row, delete: true });
        }
      );
    },
    getSectionName(code) {
      console.log("CODE:", code);
      const section = this.sections.find((item) => item.code === code);
      if (!section) {
        return "Indefinido";
      }
      return section.label;
    },
    getFilledMaskItems() {
      return this.maskItems.filter((item) => item.num > 0);
    },
    editMask() {
      console.log("EDIT");
      this.show = true;
    },
    setMask(mask) {
      this.$emit("setMask", mask);
    },
    confirmMask() {
      if (this.finalMask.trim() === "") {
        this.toast("Máscara no válida", TOAST_TYPES.ERROR);
        return;
      }
      if (!this.section) {
        this.toast("Selecciona una sección", TOAST_TYPES.ERROR);
        return;
      }
      let mask = {
        mask: this.getFinalMaks(),
        section: this.section,
        added: true,
        editing: this.editing,
        maskDetails: this.maskItems.map((item) => ({
          ...item,
          primary: item.code == this.section,
        })),
        index: this.editing ? this.index : this.maskList.length,
      };
      if (this.editing) {
        console.log(this.rowEdit);
        mask.ranges = this.rowEdit.ranges;
        mask.code = this.rowEdit.code;
      }
      this.editing = false;
      console.log(mask);
      this.$emit("updateMask", mask);
      this.selectedMaks = mask;
      this.show = false;
    },
    getLabelMask(item) {
      return new Array(parseInt(item.num))
        .fill(1)
        .map((temp) => item.mask)
        .join("")
        .toUpperCase();
    },
    getFinalMaks() {
      return this.maskItems
        .map((item) => {
          return new Array(parseInt(item.num))
            .fill(1)
            .map((temp) => item.mask)
            .join("")
            .toUpperCase();
        })
        .join("");
    },
  },
};
</script>
